import { render, staticRenderFns } from "./ItemBuildEvent.vue?vue&type=template&id=009bda2e&"
import script from "./ItemBuildEvent.vue?vue&type=script&lang=js&"
export * from "./ItemBuildEvent.vue?vue&type=script&lang=js&"
import style0 from "./ItemBuildEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports